(() => {
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  const money = (cents, format) => {
    const value = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: format || 'EUR'
      }).format(value);
    } catch (_) {
      return `${value.toFixed(2)} ${format || 'EUR'}`;
    }
  };

  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => select.form && select.form.submit());
  });

  document.querySelectorAll('[data-quantity]').forEach((quantity) => {
    const input = quantity.querySelector('input[type="number"]');
    if (!input) return;
    quantity.querySelectorAll('[data-quantity-change]').forEach((button) => {
      button.addEventListener('click', () => {
        const step = Number(input.step || 1);
        const minimum = Number(input.min || 1);
        const next = Number(input.value || minimum) + Number(button.dataset.quantityChange) * step;
        input.value = Math.max(minimum, next);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const selector = root.querySelector('[data-variant-select]');
    const formInput = root.querySelector('[data-variant-id]');
    const addButton = root.querySelector('[data-add-to-cart]');
    const price = root.querySelector('[data-product-price]');
    const comparePrice = root.querySelector('[data-product-compare-price]');
    const inventory = root.querySelector('[data-product-inventory]');
    const json = root.querySelector('[data-product-variants]');
    if (!selector || !formInput || !json) return;

    let variants = [];
    try {
      variants = JSON.parse(json.textContent);
    } catch (_) {
      return;
    }

    const updateVariant = () => {
      const variant = variants.find((entry) => String(entry.id) === selector.value);
      if (!variant) return;
      formInput.value = variant.id;
      if (price) price.textContent = money(variant.price, root.dataset.currency);
      if (comparePrice) {
        comparePrice.textContent = variant.compare_at_price > variant.price
          ? money(variant.compare_at_price, root.dataset.currency)
          : '';
        comparePrice.classList.toggle('hidden', !(variant.compare_at_price > variant.price));
      }
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.querySelector('span').textContent = variant.available
          ? addButton.dataset.availableLabel
          : addButton.dataset.soldOutLabel;
      }
      if (inventory) inventory.textContent = variant.available
        ? inventory.dataset.inStock
        : inventory.dataset.outOfStock;

      if (variant.featured_image) {
        const image = root.querySelector(`[data-media-id="${variant.featured_image.id}"]`);
        if (image) image.click();
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    selector.addEventListener('change', updateVariant);
  });

  document.querySelectorAll('[data-media-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const gallery = thumb.closest('[data-product-gallery]');
      const main = gallery && gallery.querySelector('[data-product-main-image]');
      const image = thumb.querySelector('img');
      if (!main || !image) return;
      main.src = image.dataset.fullSrc || image.src;
      main.srcset = '';
      main.alt = image.alt;
      gallery.querySelectorAll('[data-media-thumb]').forEach((item) => item.setAttribute('aria-current', 'false'));
      thumb.setAttribute('aria-current', 'true');
    });
  });

  const canvas = document.querySelector('[data-wireframe-canvas]');
  if (canvas) {
    const context = canvas.getContext('2d');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let points = [];
    let frame = 0;

    const resize = () => {
      const ratio = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.round(window.innerWidth * ratio);
      canvas.height = Math.round(window.innerHeight * ratio);
      canvas.style.width = `${window.innerWidth}px`;
      canvas.style.height = `${window.innerHeight}px`;
      context.setTransform(ratio, 0, 0, ratio, 0, 0);
      const count = Math.min(70, Math.max(28, Math.round((window.innerWidth * window.innerHeight) / 22000)));
      points = Array.from({ length: count }, () => ({
        x: Math.random() * window.innerWidth,
        y: Math.random() * window.innerHeight,
        vx: (Math.random() - 0.5) * 0.18,
        vy: (Math.random() - 0.5) * 0.18
      }));
    };

    const render = () => {
      context.clearRect(0, 0, window.innerWidth, window.innerHeight);
      points.forEach((point, index) => {
        if (!reducedMotion.matches) {
          point.x += point.vx;
          point.y += point.vy;
          if (point.x <= 0 || point.x >= window.innerWidth) point.vx *= -1;
          if (point.y <= 0 || point.y >= window.innerHeight) point.vy *= -1;
        }
        for (let otherIndex = index + 1; otherIndex < points.length; otherIndex += 1) {
          const other = points[otherIndex];
          const distance = Math.hypot(point.x - other.x, point.y - other.y);
          if (distance < 155) {
            context.strokeStyle = `rgba(34, 211, 238, ${(1 - distance / 155) * 0.58})`;
            context.lineWidth = 1.25;
            context.beginPath();
            context.moveTo(point.x, point.y);
            context.lineTo(other.x, other.y);
            context.stroke();
          }
        }

        context.fillStyle = 'rgba(103, 232, 249, 0.48)';
        context.beginPath();
        context.arc(point.x, point.y, 1.25, 0, Math.PI * 2);
        context.fill();
      });
      if (!reducedMotion.matches) frame = window.requestAnimationFrame(render);
    };

    const restart = () => {
      window.cancelAnimationFrame(frame);
      resize();
      render();
    };
    window.addEventListener('resize', restart, { passive: true });
    reducedMotion.addEventListener('change', restart);
    restart();
  }
})();
